import apiService from "./apiService";

const paymentService = {
    async acceptPayment(transaction) {
        try {
            const resp = await apiService.post(`payments/save`, transaction, true);
            return resp.data;
        }
        catch {
            return { syspk_te: -1, recMarker: 'An error occured while processing the request' };
        }
    }
}

export default paymentService;